function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
export default (({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.65 11.24L14.65 5.24C14.36 4.99 13.94 4.93 13.58 5.09C13.23 5.25 13 5.61 13 6V9.03C2 9.68 2 21 2 21C2 21 4.79 15.47 13 15.04V18C13 18.39 13.23 18.75 13.58 18.91C13.71 18.97 13.86 19 14 19C14.23 19 14.47 18.92 14.65 18.76L21.65 12.76C21.87 12.57 22 12.29 22 12C22 11.71 21.87 11.43 21.65 11.24Z",
  fill: fill || 'currentColor'
})));
//# sourceMappingURL=ShareArrow.js.map